import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function yearBonusReducer() {
    return combineReducers({
        TestTable_POx_Ybd_Periods: createItemReducer('YearBonus', 'TestTable.POx_Ybd_Periods', false),
        SalaryChangeData_POx_Ybd_CheckAccess: createItemReducer('YearBonus', 'SalaryChangeData.POx_Ybd_CheckAccess', false),
        SalaryChangeData_POx_Ybd_CheckAccess_Params: createItemReducerParams("YearBonus", 'SalaryChangeData.POx_Ybd_CheckAccess'),
        SalaryChangeData_POx_Ybd_Periods: createItemReducer('YearBonus', 'SalaryChangeData.POx_Ybd_Periods', false)
    });
}